import React from 'react';
import { motion } from 'framer-motion';
import { Gift, BookOpen, Users, RefreshCw, Target } from 'lucide-react';
const BONUSES = [{
  icon: BookOpen,
  title: 'Plantillas de Copy para Ads',
  desc: '+50 plantillas de copy probadas para productos digitales. Solo copiar, pegar y adaptar.',
  value: '$29.990'
}, {
  icon: Target,
  title: 'Guía de Ángulos de Venta',
  desc: 'El framework completo para encontrar los ángulos que más venden en tu nicho.',
  value: '$19.990'
}, {
  icon: Users,
  title: 'Acceso a Comunidad Privada',
  desc: 'Grupo exclusivo de media buyers y agencias compartiendo resultados y estrategias.',
  value: '$14.990'
}, {
  icon: RefreshCw,
  title: 'Updates de por Vida',
  desc: 'Cada nueva función, template y mejora que agreguemos. Sin costo extra. Para siempre.',
  value: 'Incalculable'
}];
export function BonusSection() {
  return <section className="py-16 md:py-24 bg-black relative overflow-hidden" data-id="element-17">
      <div className="container mx-auto px-4" data-id="element-18">
        <div className="text-center mb-12 md:mb-16" data-id="element-19">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-20">
            Pero eso no es todo...
          </h2>
          <p className="text-lg md:text-xl text-gray-400" data-id="element-21">
            También recibes estos{' '}
            <span className="text-purple-500 font-bold" data-id="element-22">BONUS GRATIS</span> al
            unirte hoy.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-23">
          {BONUSES.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white/5 border border-white/10 p-6 md:p-8 rounded-2xl relative overflow-hidden group hover:border-purple-500/40 transition-colors" data-id="element-24">
              <div className="absolute top-4 right-4 bg-purple-500/20 text-purple-300 text-[10px] font-bold px-2 py-1 rounded uppercase tracking-wider border border-purple-500/20" data-id="element-25">
                Bonus #{i + 1}
              </div>

              <div className="w-12 h-12 bg-gray-800 rounded-lg flex items-center justify-center mb-6 text-white group-hover:bg-purple-900/50 transition-colors" data-id="element-26">
                <bonus.icon className="w-6 h-6" data-id="element-27" />
              </div>

              <h3 className="text-xl font-bold text-white mb-3" data-id="element-28">
                {bonus.title}
              </h3>
              <p className="text-gray-400 text-sm mb-4 min-h-[40px]" data-id="element-29">
                {bonus.desc}
              </p>

              <div className="text-sm font-medium text-gray-500" data-id="element-30">
                Valor:{' '}
                <span className="text-gray-300 line-through decoration-red-500/50" data-id="element-31">
                  {bonus.value}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}